/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of GarageClerk::Application.
 * @version f70d1ff7ed424bc9ae58af9955e78e1dfb7fcdc4044bc6d88b1ed0738f8a39fc
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: false,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /billing_review_views/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingReviewViewPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing_review_views"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing_review_views/:billing_review_view_token/decision(.:format)
 * @param {any} billingReviewViewToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingReviewViewDecisionPath = /*#__PURE__*/ __route({"billing_review_view_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing_review_views"],[2,[7,"/"],[2,[3,"billing_review_view_token"],[2,[7,"/"],[2,[6,"decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_selection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companySelectionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company_selection"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/billing_reviews/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyBillingReviewPath = /*#__PURE__*/ __route({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/billing_reviews/:billing_review_id/decision(.:format)
 * @param {any} companyId
 * @param {any} billingReviewId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyBillingReviewDecisionPath = /*#__PURE__*/ __route({"company_id":{"r":true},"billing_review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[3,"billing_review_id"],[2,[7,"/"],[2,[6,"decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/history(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyHistoryPath = /*#__PURE__*/ __route({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/locations/:location_id/vehicles/:vehicle_id/history(.:format)
 * @param {any} companyId
 * @param {any} locationId
 * @param {any} vehicleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyLocationVehicleHistoryPath = /*#__PURE__*/ __route({"company_id":{"r":true},"location_id":{"r":true},"vehicle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"vehicle_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/locations/:location_id/vehicles/:vehicle_id/report(.:format)
 * @param {any} companyId
 * @param {any} locationId
 * @param {any} vehicleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyLocationVehicleReportPath = /*#__PURE__*/ __route({"company_id":{"r":true},"location_id":{"r":true},"vehicle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"vehicle_id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/proposals/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyProposalPath = /*#__PURE__*/ __route({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/proposals/:proposal_id/decision(.:format)
 * @param {any} companyId
 * @param {any} proposalId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyProposalDecisionPath = /*#__PURE__*/ __route({"company_id":{"r":true},"proposal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"proposal_id"],[2,[7,"/"],[2,[6,"decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/recordings/:recording_id/attachments/:id(.:format)
 * @param {any} companyId
 * @param {any} recordingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyRecordingAttachmentPath = /*#__PURE__*/ __route({"company_id":{"r":true},"recording_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/reschedules/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyReschedulePath = /*#__PURE__*/ __route({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"reschedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/companies/:company_id/reschedules/:reschedule_id/decision(.:format)
 * @param {any} companyId
 * @param {any} rescheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalCompanyRescheduleDecisionPath = /*#__PURE__*/ __route({"company_id":{"r":true},"reschedule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"reschedules"],[2,[7,"/"],[2,[3,"reschedule_id"],[2,[7,"/"],[2,[6,"decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/email_verifications/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalEmailConfirmationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"email_verifications"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/email_verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalEmailVerificationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"email_verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/email_verifications/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalEmailVerificationsConfirmationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"email_verifications"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalHistoryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/bays/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationBayPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationCustomerPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/detailing_products/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationDetailingProductPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"detailing_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationJobFiscalDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationRequestPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/proposal_draft/edit(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationRequestProposalDraftPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"proposal_draft"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/services/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationServicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/service_offerings/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationServiceOfferingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"service_offerings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/:id/edit(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLocationVehiclePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /passwords/:token/edit(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPasswordPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /facebook/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instagram/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invitation_acceptance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationAcceptancePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invitation_acceptance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:location_id/bays/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationBayPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/bays(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationBaysPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bays"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/calendar(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCalendarPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCustomerPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers/:customer_id/authorization(.:format)
 * @param {any} locationId
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCustomerAuthorizationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers/:customer_id/deletion(.:format)
 * @param {any} locationId
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCustomerDeletionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customer_reuses(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCustomerReusesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customer_reuses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationCustomersPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDashboardPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:location_id/detailing_products/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDetailingProductPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"detailing_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/detailing_products/:detailing_product_id/stock_adjustments(.:format)
 * @param {any} locationId
 * @param {any} detailingProductId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDetailingProductStockAdjustmentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"detailing_product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"detailing_products"],[2,[7,"/"],[2,[3,"detailing_product_id"],[2,[7,"/"],[2,[6,"stock_adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/detailing_products(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDetailingProductsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"detailing_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/directory_matches(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationDirectoryMatchesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"directory_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/activity(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobActivityPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/advance_requests(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobAdvanceRequestsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"advance_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/assignment(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobAssignmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"assignment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/billing_reviews/:id(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBillingReviewPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/billing_reviews/:billing_review_id/approval(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} billingReviewId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBillingReviewApprovalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"billing_review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[3,"billing_review_id"],[2,[7,"/"],[2,[6,"approval"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/billing_reviews/:billing_review_id/confirmation(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} billingReviewId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBillingReviewConfirmationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"billing_review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[3,"billing_review_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/billing_reviews/:billing_review_id/publication(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} billingReviewId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBillingReviewPublicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"billing_review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[3,"billing_review_id"],[2,[7,"/"],[2,[6,"publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/billing_reviews(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBillingReviewsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/job_board(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBoardPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"job_board"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/board_position(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobBoardPositionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"board_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents/:id(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobFiscalDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents/:fiscal_document_id/issuance(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} fiscalDocumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobFiscalDocumentIssuancePath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"fiscal_document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[2,[7,"/"],[2,[3,"fiscal_document_id"],[2,[7,"/"],[2,[6,"issuance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents/:fiscal_document_id/payment_allocations(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} fiscalDocumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobFiscalDocumentPaymentAllocationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"fiscal_document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[2,[7,"/"],[2,[3,"fiscal_document_id"],[2,[7,"/"],[2,[6,"payment_allocations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents/:fiscal_document_id/refresh(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} fiscalDocumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobFiscalDocumentRefreshPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"fiscal_document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[2,[7,"/"],[2,[3,"fiscal_document_id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobFiscalDocumentsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/payment_postings(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobPaymentPostingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"payment_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/product_consumptions(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobProductConsumptionsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"product_consumptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/progress(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobProgressPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/reschedules/:reschedule_id/expiry(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {any} rescheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobRescheduleExpiryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"reschedule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"reschedules"],[2,[7,"/"],[2,[3,"reschedule_id"],[2,[7,"/"],[2,[6,"expiry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/reschedules(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobReschedulesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"reschedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationJobsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:recording_id/directory_links(.:format)
 * @param {any} locationId
 * @param {any} recordingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingDirectoryLinksPath = /*#__PURE__*/ __route({"location_id":{"r":true},"recording_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"directory_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:recording_id/export(.:format)
 * @param {any} locationId
 * @param {any} recordingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingExportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"recording_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:recording_id/history(.:format)
 * @param {any} locationId
 * @param {any} recordingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingHistoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"recording_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:recording_id/operational_notifications/:operational_notification_id/retry(.:format)
 * @param {any} locationId
 * @param {any} recordingId
 * @param {any} operationalNotificationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingOperationalNotificationRetryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"recording_id":{"r":true},"operational_notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"operational_notifications"],[2,[7,"/"],[2,[3,"operational_notification_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:recording_id/operational_notifications(.:format)
 * @param {any} locationId
 * @param {any} recordingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingOperationalNotificationsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"recording_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"operational_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRecordingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/completion(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestCompletionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/customer(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestCustomerPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"customer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/proposal_draft(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestProposalDraftPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"proposal_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/proposal_publication(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestProposalPublicationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"proposal_publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/response(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestResponsePath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/routing(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestRoutingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"routing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationRequestsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/services/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationServicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/services/:service_id/archival(.:format)
 * @param {any} locationId
 * @param {any} serviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationServiceArchivalPath = /*#__PURE__*/ __route({"location_id":{"r":true},"service_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"service_id"],[2,[7,"/"],[2,[6,"archival"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/service_offerings/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationServiceOfferingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"service_offerings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/service_offerings(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationServiceOfferingsPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"service_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/services(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationServicesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/settings/location(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSettingsLocationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/settings/location_schedule(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationSettingsLocationSchedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"location_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/:id(.:format)
 * @param {any} locationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVehiclePath = /*#__PURE__*/ __route({"location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/:vehicle_id/history(.:format)
 * @param {any} locationId
 * @param {any} vehicleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVehicleHistoryPath = /*#__PURE__*/ __route({"location_id":{"r":true},"vehicle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"vehicle_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/:vehicle_id/ownership(.:format)
 * @param {any} locationId
 * @param {any} vehicleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVehicleOwnershipPath = /*#__PURE__*/ __route({"location_id":{"r":true},"vehicle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"vehicle_id"],[2,[7,"/"],[2,[6,"ownership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/:vehicle_id/report(.:format)
 * @param {any} locationId
 * @param {any} vehicleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVehicleReportPath = /*#__PURE__*/ __route({"location_id":{"r":true},"vehicle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"vehicle_id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicle_reuses(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVehicleReusesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicle_reuses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locationVehiclesPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customer_portal/email_verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPortalEmailVerificationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"email_verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPortalPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_portal/session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPortalSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"customer_portal"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/bays/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationBayPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"bays"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationCustomerPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/customers/:customer_id/deletion/new(.:format)
 * @param {any} locationId
 * @param {any} customerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationCustomerDeletionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"customer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"deletion"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/detailing_products/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationDetailingProductPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"detailing_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/detailing_products/:detailing_product_id/stock_adjustments/new(.:format)
 * @param {any} locationId
 * @param {any} detailingProductId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationDetailingProductStockAdjustmentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"detailing_product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"detailing_products"],[2,[7,"/"],[2,[3,"detailing_product_id"],[2,[7,"/"],[2,[6,"stock_adjustments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/advance_requests/new(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobAdvanceRequestPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"advance_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/billing_reviews/new(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobBillingReviewPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"billing_reviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/fiscal_documents/new(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobFiscalDocumentPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"fiscal_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/payment_postings/new(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobPaymentPostingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"payment_postings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/product_consumptions/new(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobProductConsumptionPath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"product_consumptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/jobs/:job_id/reschedules/new(.:format)
 * @param {any} locationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationJobReschedulePath = /*#__PURE__*/ __route({"location_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"reschedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/recordings/:recording_id/operational_notifications/new(.:format)
 * @param {any} locationId
 * @param {any} recordingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationRecordingOperationalNotificationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"recording_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"recording_id"],[2,[7,"/"],[2,[6,"operational_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationRequestPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/requests/:request_id/proposal_draft/new(.:format)
 * @param {any} locationId
 * @param {any} requestId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationRequestProposalDraftPath = /*#__PURE__*/ __route({"location_id":{"r":true},"request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"request_id"],[2,[7,"/"],[2,[6,"proposal_draft"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/services/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationServicePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/service_offerings/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationServiceOfferingPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"service_offerings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/new(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationVehiclePath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:location_id/vehicles/:vehicle_id/ownership/new(.:format)
 * @param {any} locationId
 * @param {any} vehicleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLocationVehicleOwnershipPath = /*#__PURE__*/ __route({"location_id":{"r":true},"vehicle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"vehicles"],[2,[7,"/"],[2,[3,"vehicle_id"],[2,[7,"/"],[2,[6,"ownership"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /passwords/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthGooglePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/google/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthGoogleCallbackPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /passwords/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passwordPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passwordsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /proposal_views/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalViewPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proposal_views"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /proposal_views/:proposal_view_token/decision(.:format)
 * @param {any} proposalViewToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalViewDecisionPath = /*#__PURE__*/ __route({"proposal_view_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"proposal_views"],[2,[7,"/"],[2,[3,"proposal_view_token"],[2,[7,"/"],[2,[6,"decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recordings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordingPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reschedule_views/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rescheduleViewPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reschedule_views"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reschedule_views/:reschedule_view_token/decision(.:format)
 * @param {any} rescheduleViewToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rescheduleViewDecisionPath = /*#__PURE__*/ __route({"reschedule_view_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reschedule_views"],[2,[7,"/"],[2,[3,"reschedule_view_token"],[2,[7,"/"],[2,[6,"decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionCreatePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signUpPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sites/:site_id/locations/:id(.:format)
 * @param {any} siteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const siteLocationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sites/:site_id/locations/:location_id/enquiry(.:format)
 * @param {any} siteId
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const siteLocationEnquiryPath = /*#__PURE__*/ __route({"site_id":{"r":true},"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"enquiry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stripe/connect_webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhooksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"connect_webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeWebhooksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAccountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/account_closure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAccountClosurePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"account_closure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userActivityPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBillingPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/billing_checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBillingCheckoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"billing_checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/billing_notice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBillingNoticePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"billing_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/billing_portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBillingPortalPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"billing_portal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/customer_deletions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userCustomerDeletionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"customer_deletions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/customer_deletions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userCustomerDeletionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"customer_deletions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/facebook_authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFacebookAuthorizationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"facebook_authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/facebook_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFacebookPagePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"facebook_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/facebook_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFacebookPagesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"facebook_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/financial_archives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFinancialArchivePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"financial_archives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/instagram_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userInstagramAccountPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"instagram_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/instagram_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userInstagramAccountsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"instagram_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/instagram_authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userInstagramAuthorizationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"instagram_authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userIntegrationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userIntegrationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userInvitationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/locations/:location_id/activation(.:format)
 * @param {any} locationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userLocationActivationPath = /*#__PURE__*/ __route({"location_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"location_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/location_histories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userLocationHistoriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"location_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/location_histories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userLocationHistoryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"location_histories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userLocationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userMemberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/members/:member_id/activation(.:format)
 * @param {any} memberId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userMemberActivationPath = /*#__PURE__*/ __route({"member_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"member_id"],[2,[7,"/"],[2,[6,"activation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/members/:member_id/location_access(.:format)
 * @param {any} memberId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userMemberLocationAccessPath = /*#__PURE__*/ __route({"member_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"member_id"],[2,[7,"/"],[2,[6,"location_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userProfilePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/resource_selection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userResourceSelectionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"resource_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/stripe_connect_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userStripeConnectAccountPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"stripe_connect_account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/stripe_connect_account_return(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userStripeConnectAccountReturnPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"stripe_connect_account_return"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userTeamPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/website(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWebsitePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"website"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/website/domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWebsiteDomainPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/website/domain/verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWebsiteDomainVerificationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"domain"],[2,[7,"/"],[2,[6,"verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/website/locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWebsiteLocationPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/whatsapp_authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWhatsappAuthorizationPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"whatsapp_authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/whatsapp_numbers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWhatsappNumberPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"whatsapp_numbers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/whatsapp_numbers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userWhatsappNumbersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"whatsapp_numbers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /whatsapp/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsappWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"whatsapp"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

